export default function CardRegistration({ index, item }) {
  return (
    <>
      <div
        className="mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500 lg:mb-10"
        style={{
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          width: "58px",
          height: "58px",
        }}
      >
        {index + 1}
      </div>
      {item?.title && (
        <p className="mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold">
          {item.title}
        </p>
      )}
      <p className="text-bbc-gray">{item.content}</p>
    </>
  );
}
